/* import __COLOCATED_TEMPLATE__ from './add-tag-to-conversation-operation.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { type AttributeInfoResolver } from '@intercom/embercom-prosemirror-composer';
import type { NodeSelection } from 'prosemirror-state';
import { inject as service } from '@ember/service';
import { generateInlineAttributes } from 'embercom/components/workflows/graph-editor/helpers/template-helpers';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  resolver: any;
  onUpdateNode: (state: Record<string, unknown>, selection?: NodeSelection) => void;
  closePopover: () => void;
}

export default class AddTagToConversationOperation extends Component<Args> {
  @service store: $TSFixMe;
  @service declare intl: IntlService;

  @action
  onUpdateAttributeIdentifier(identifier: string): void {
    this.args.onUpdateNode({
      subjectIdentifier: identifier,
      attributeValueType: 'fin',
    });

    this.args.closePopover();
  }

  get conversationTagResolver(): AttributeInfoResolver {
    // eslint-disable-next-line ember/no-side-effects
    this.args.resolver.inlineAttributes = this.conversationTagInlineAttributes;
    return this.args.resolver;
  }

  get conversationTagInlineAttributes() {
    let tags = this.store.peekAll('tag');
    return generateInlineAttributes(tags, 'tag', 'tag', this.intl);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinCustom::AiPromptDataPopover::AddTagToConversationOperation': typeof AddTagToConversationOperation;
  }
}
